import React, { Component } from 'react';
import FileInputReader from '../FileInputReader';
import FilePopulateMutation from '../../mutations/FilePopulate';
import AllertDialog from '../AllertDialog';
import HeightDownAnimation from '../HeightDownAnimation';
import { StartSessionDatePicker } from '../AdminDatePicker/StartSessionDatePicker';
import { EndSessionDatePicker } from '../AdminDatePicker/EndSessionDatePicker';
import { FormattedMessage } from 'react-intl';
import ScenarioSessionDropdown from '../ScenarioSessionDropdown';
import Tooltip from '../Tooltip';

type Scenario = {
  label: string;
  value: string;
}

interface ISessionFormState {
  showCorrectUpload: boolean;
  showUploadErrors: boolean;
  uploadErrors: string;
  name: string;
  startDate: Date;
  endDate: Date;
  gamesData: any;
  scenario: Scenario;
}

export class SessionForm extends Component<any,any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showCorrectUpload: false,
      showUploadErrors: false,
      uploadErrors: '',
      name: '',
      startDate: null,
      endDate: null,
      gamesData: null,
      scenario: null
    };
  }
  
  getScenarios(){
    return this.props.scenarios.map((scenario: any) => ({
      label: scenario.name,
      value: scenario.id
    }))
  }
  
  setScenario(scenario: Scenario){
    this.setState({
      ...this.state,
      scenario
    }) 
  }
  
  setName(name: string){
    this.setState({
      ...this.state,
      name: name
    })
  }
  
  setStartDate(startDate: Date | null) {
    if (startDate && this.state.startDate < startDate) {
      this.setState({
        ...this.state,
        startDate: startDate
      })
    }
  }
  
  setEndDate(endDate: Date | null) {
    if(endDate && this.state.startDate < endDate){
      this.setState({
        ...this.state,
        endDate: endDate
      })
    }
  }
  
  setGamesData(data: any, valid: boolean, errors: []){
    try {
      if (valid) {
        this.setState({
          ...this.state,
          showCorrectUpload: true,    
          gamesData: data
        })
      } else {
        this.setState({
          ...this.state,
          showUploadErrors: true,
          uploadErrors: (
            <div style={{ maxHeight: '300px', overflow: 'auto' }}>
              {errors.map((err, y) => <div key={y}>{err}</div>)}
            </div>
          )
        });
      }
    } catch (error) {
      throw error;
    }
  }
  
  /** 
   * @todo change mutation
  */
  loadSessionsFile(mutation: Function) {
    mutation({
      variables: {
        data: this.state.gamesData,
        name: this.state.name,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        scenario: this.state.scenario
      }
    });
  }
  
  /**
  * @todo validation on gamesData?
  */
  buttonDisabled(){
    const { startDate, endDate, name, scenario } = this.state;
    return (
      !name || !startDate || !endDate || !scenario
    )
  }
  
  onCreateClick(mutation: Function){
    mutation({
      variables: {
        data: this.state.gamesData,
        name: this.state.name,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        scenario: this.state.scenario.value
      }
    });
    this.setState({
      ...this.state,
      gamesData: null,
      name: '',
      startDate: null,
      endDate: null,
      scenario: null
    });
    this.props.closed();
  }

  render() {
    const {
      show,
      form: { title, height, inputs, cta, upload },
      closed
    } = this.props;

    const { uploadErrors, showUploadErrors, showCorrectUpload } = this.state;

    const formClass = ['Form', show ? 'is-visible' : ''].join(' ');

    let disableButton = true;

    const inputsTpl = inputs.map((field: any) => {
      disableButton = disableButton && field.value.trim() !== '';
      
      return (
        <div className="Form-column Form-column--vertical" key={field.name}>
          {showUploadErrors && (
            <AllertDialog
              title={<span style={{ color: 'red' }}>Upload failed</span>}
              body={uploadErrors}
              description={''}
              show={showUploadErrors}
              onClick={() => this.setState({ showUploadErrors: false })}
              closeDialogClicked={() =>
                this.setState({ showUploadErrors: false })
              }
            />
          )}
          {showCorrectUpload && (
            <AllertDialog
              title={<span style={{ color: 'green' }}>Upload completed</span>}
              description={'File uploaded successfully!'}
              show={showCorrectUpload}
              onClick={() => this.setState({ showCorrectUpload: false })}
              closeDialogClicked={() =>
                this.setState({ showCorrectUpload: false })
              }
            />
          )}
          
          <label className="Form-label Form-label--sm">
            Insert the session name manually
            <Tooltip icon description='creationSession:tooltip' />
					</label>
          <input
            value={this.state.name}            
            onChange={(ev) => this.setName(ev.currentTarget.value)}
            placeholder={field.placeholder}
            name={field.name}
            type={field.type}
            className="Form-input"
            autoComplete="off"
            style={{ width: '330px' }}
          />
          <StartSessionDatePicker value={this.state.startDate} onChange={(date: Date | null) => this.setStartDate(date)}/>
          <EndSessionDatePicker value={this.state.endDate} onChange={(date: Date | null) => this.setEndDate(date)}/>
          <ScenarioSessionDropdown 
            options={this.getScenarios()}
            selected={this.state.scenario}
            onSelect={(scenario: Scenario) => this.setScenario(scenario)}
          />
        </div>
      );
    });

    return (
      <FilePopulateMutation>
        {(filePopulate: any) => (
          <HeightDownAnimation show={show} height={height}>
            <div className={formClass}>
              <button className="Form-close" onClick={closed}>
                <FormattedMessage id='addSession:close:icon'/>
							</button>
              <h2 className="Form-title">{title}</h2>
              <div
                className="Form-content"
                style={{
                  margin: '0 0 20px',
                  justifyContent: 'center',
                  alignItems: 'flex-start'
                }}
              >
                {inputsTpl}
                {/* <span
                  style={{
                    display: 'inline-block',
                    margin: '30px 40px 0 0px',
                    fontSize: '12px'
                  }}
                >
                  
								</span> */}
                {upload && (
                  <FileInputReader
                    loadCallback={(data: any, valid: boolean, errors: []) =>
                      /* this.loadSessionsFile(data, valid, errors, filePopulate) */
                      this.setGamesData(data, valid, errors)
                    }
                    uploadCta={upload}
                    id="upload-sessions"
                  />
                )}
              </div>
              <button
                disabled={this.buttonDisabled()}
                className="Form-button"
                onClick={() => this.onCreateClick(filePopulate)}
              >
                {cta}
              </button>
            </div>
          </HeightDownAnimation>
        )}
      </FilePopulateMutation>
    );
  }
}